import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FamilyMember, FamilyRelation } from '@crm/shared/persons/types';

@Injectable({
  providedIn: 'root',
})
export class PersonFamilyPageSharedService {
  private personRelation$: Observable<FamilyRelation | null>;
  private family$: Observable<FamilyMember[]>;

  getPersonRelation(): Observable<FamilyRelation | null> {
    return this.personRelation$;
  }

  getFamilyMembers(): Observable<FamilyMember[]> {
    return this.family$;
  }

  setPersonRelation(personRelation$: Observable<FamilyRelation | null>): void {
    this.personRelation$ = personRelation$;
  }

  setFamilyMembers(family$: Observable<FamilyMember[]>): void {
    this.family$ = family$;
  }
}
